<template>
  <b-table
    class="tabela-consulta-boletos"
    :items="items"
    :fields="fields"
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    :tbody-tr-class="retornarClasseLinha"
    head-variant="light"
    stacked="md"
    show-empty
    striped
    hover
    @sort-changed="aoMudarOrdenacao"
  >
    <template #cell(detalhe)="linha">
      <b-button
        v-if="linha.item.itens && linha.item.itens.length > 0"
        size="sm"
        variant="outline-default"
        @click="linha.toggleDetails"
      >
        {{
          linha.detailsShowing ? $t('FINANCEIRO.OCULTAR_DETALHE') : $t('FINANCEIRO.DETALHAR')
        }}
      </b-button>
    </template>

    <template #cell(aluno)="linha">
      <span v-if="linha.item.aluno">{{ linha.item.aluno }}</span>
      <span v-else class="text-muted font-italic">
        {{ $t('FINANCEIRO.BOLETO_SEM_VINCULO') }}
      </span>
    </template>

    <template #cell(valorTotal)="linha">
      {{ formatarReal(linha.item.valorTotal) }}
    </template>

    <template #cell(dataEmissao)="linha">
      {{ formatarData(linha.item.dataEmissao) }}
    </template>

    <template #cell(dataVencimento)="linha">
      {{ formatarData(linha.item.dataVencimento) }}
    </template>

    <template #cell(dataPagamento)="linha">
      {{ formatarData(linha.item.dataPagamento) }}
    </template>

    <template #cell(statusBoletoDescricao)="linha">
      <div
        class="estilo-status-tabela"
        v-if="corDoStatus(linha.item.statusBoletoDescricao)"
        :style="{ background: corDoStatus(linha.item.statusBoletoDescricao) }"
      >
        {{ linha.item.statusBoletoDescricao }}
      </div>
      <div v-else>
        {{ linha.item.statusBoletoDescricao }}
      </div>
    </template>

    <template #row-details="linha">
      <b-card class="mb-0">
        <b-table
          :items="linha.item.itens"
          :fields="fieldsItens"
          :empty-text="$t('GERAL.NENHUM_REGISTRO')"
          head-variant="light"
          small
          show-empty
          striped
        >
          <template #cell(valor)="item">
            {{ formatarReal(item.item.valor) }}
          </template>
          <template #cell(desconto)="item">
            {{ item.item.desconto ? formatarReal(item.item.desconto) : '—' }}
          </template>
          <template #cell(total)="item">
            {{ formatarReal(item.item.total) }}
          </template>
          <template #custom-foot>
            <b-tr>
              <b-th>{{ $t('FINANCEIRO.TOTAL_BOLETO') }}</b-th>
              <b-th>{{ formatarReal(somar(linha.item.itens, 'valor')) }}</b-th>
              <b-th>
                {{ formatarReal(somar(linha.item.itens, 'desconto')) }}
              </b-th>
              <b-th>{{ formatarReal(somar(linha.item.itens, 'total')) }}</b-th>
            </b-tr>
          </template>
        </b-table>
      </b-card>
    </template>
  </b-table>
</template>
<script>
import helpers from '@/common/utils/helpers';

export default {
  props: {
    items: { type: Array, default: Array },
  },
  data() {
    return {
      coresStatus: {
        Cancelado: 'red',
        Liquidado: 'green',
        'Liquidado Parcialmente': '#7ccd7c',
        Estornado: '#3a443a',
        Aberto: '#fbcd00',
      },
      classesLinha: {
        Liquidado: 'linha-liquidado',
        'Liquidado Parcialmente': 'linha-liquidado-parcialmente',
        Cancelado: 'linha-cancelado',
        Estornado: 'linha-estornado',
      },
      fields: [
        {
          key: 'detalhe',
          label: '',
        },
        {
          key: 'nossoNumero',
          label: this.$t('FINANCEIRO.NOSSO_NUMERO'),
          sortable: true,
        },
        {
          key: 'seuNumero',
          label: this.$t('FINANCEIRO.SEU_NUMERO'),
          sortable: true,
        },
        {
          key: 'aluno',
          label: this.$t('ACADEMICO_MATRICULAS.ALUNO'),
          sortable: true,
        },
        {
          key: 'matriculaCodigo',
          label: this.$t('FINANCEIRO.MATRICULA'),
        },
        {
          key: 'responsavel',
          label: this.$t('FINANCEIRO.RESPONSAVEL'),
        },
        {
          key: 'responsavelCpf',
          label: this.$t('FINANCEIRO.CPF_RESPONSAVEL'),
        },
        {
          key: 'dataEmissao',
          label: this.$t('FINANCEIRO.DATA_EMISSAO'),
          sortable: true,
        },
        {
          key: 'dataVencimento',
          label: this.$t('FINANCEIRO_CONTAS_RECEBER.DATA_VENCIMENTO'),
          sortable: true,
        },
        {
          key: 'valorTotal',
          label: this.$t('GERAL.VALOR_BRL'),
          sortable: true,
        },
        {
          key: 'statusBoletoDescricao',
          label: this.$t('FINANCEIRO.SITUACAO_BOLETO'),
        },
        {
          key: 'dataPagamento',
          label: this.$t('FINANCEIRO_CONTAS_RECEBER.DATA_PAGAMENTO'),
          sortable: true,
        },
      ],
      fieldsItens: [
        {
          key: 'tipoConta',
          label: this.$t('FINANCEIRO.TIPO_CONTA'),
        },
        {
          key: 'valor',
          label: this.$t('GERAL.VALOR_BRL'),
        },
        {
          key: 'desconto',
          label: this.$t('FINANCEIRO.DESCONTO'),
        },
        {
          key: 'total',
          label: this.$t('FINANCEIRO.VALOR_FINAL'),
        },
      ],
    };
  },
  methods: {
    corDoStatus(descricao) {
      return this.coresStatus[descricao] ?? null;
    },
    retornarClasseLinha(item, type) {
      if (!item || type !== 'row') return;
      return this.classesLinha[item.statusBoletoDescricao] ?? null;
    },
    formatarReal(valor) {
      return helpers.formatarReal(valor ?? 0);
    },
    formatarData(data) {
      return data ? helpers.formatarDataBr(data) : '—';
    },
    somar(itens, campo) {
      return (itens ?? []).reduce((acc, item) => acc + (item[campo] ?? 0), 0);
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      this.$emit('alterar-ordenacao', sortBy, sortDesc);
    },
  },
};
</script>

<style>
.tabela-consulta-boletos tbody tr.linha-liquidado > td {
  background-color: #eaf7ea !important;
  border-top: 1px solid #a8dba8 !important;
}
.tabela-consulta-boletos tbody tr.linha-liquidado-parcialmente > td {
  background-color: #f4fbf4 !important;
  border-top: 1px solid #cbe8cb !important;
}
.tabela-consulta-boletos tbody tr.linha-cancelado > td {
  background-color: #fdecec !important;
  border-top: 1px solid #f3c4c4 !important;
}
.tabela-consulta-boletos tbody tr.linha-estornado > td {
  background-color: #eef0ee !important;
  border-top: 1px solid #cfd4cf !important;
}
</style>
